import { useSearchParams } from 'react-router-dom';

export const useSubscriptionQuery = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	const billing = searchParams.get('billing') || 'monthly';

	const plan = searchParams.get('plan') || null;

	const step = Number(searchParams.get('step')) || 1;

	const updateQuery = (values) => {
		const params = new URLSearchParams(searchParams);

		Object.entries(values).forEach(([key, value]) => {
			if (value === undefined || value === null) {
				params.delete(key);
			} else {
				params.set(key, value);
			}
		});

		setSearchParams(params);
	};

	return {
		billing,
		plan,
		step,
		updateQuery,
	};
};
